module.exports = __webpack_public_path__ + "static/media/salon-2-min.2e76d383.png";